import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss']
})
export class CalculatorComponent {
  currentInput: string = '';
  result: string = '0';

  // Mapea las teclas presionadas a las funciones de la calculadora
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    const key = event.key;

    if (!isNaN(Number(key))) {
      // Números del 0-9
      this.addToInput(key);
    } else if (['+', '-', '*', '/'].includes(key)) {
      // Operaciones matemáticas
      this.addToInput(key);
    } else if (key === 'Enter' || key === '=') {
      // Enter o '=' para calcular
      this.calculateResult();
      event.preventDefault(); // Evita el comportamiento predeterminado de Enter
    } else if (key === 'Backspace') {
      // Backspace para borrar
      this.deleteLast();
    } else if (key === 'Escape' || key.toLowerCase() === 'c') {
      // Escape o tecla "C" para limpiar
      this.clearInput();
    } else if (key === '.') {
      // Punto decimal
      this.addToInput(key);
    }
  }

  addToInput(value: string): void {
    this.currentInput += value;
  }

  clearInput(): void {
    this.currentInput = '';
    this.result = '0';
  }

  calculateResult(): void {
    try {
      this.result = eval(this.currentInput).toString();
    } catch {
      this.result = 'Error';
    }
  }

  deleteLast(): void {
    this.currentInput = this.currentInput.slice(0, -1);
  }
}